import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/newTab.svg';

export const IconNewTab = createIconComponent(Icon);
